import { t } from 'i18next';
import { getLinkSupport } from '~/helpers/support';
import {
  ContainerArea,
  ContainerFAQ, ContainerQuestion, Footer, HeaderFAQ, HeaderQuestion,
} from './styles';
import { useState } from 'react';
import { ChevronRight, SearchNewIcon } from '~/icons';
import { colors } from '~/styles/colors';
import externalLink from '../../assets/img/sidebar/external-link.svg';
import { FaqQuestions } from './constants';

export const FAQRemoteControl = (): JSX.Element => {
  const [questionOpen, setQuestionOpen] = useState<number | null>(null);
  const [search, setSearch] = useState<string>('');
  const normalize = (text: string) => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const filteredOptions = search === '' ? FaqQuestions : FaqQuestions.filter((opt) => normalize(opt.question + opt.answer.text + opt.answer.list.join(' ')).includes(normalize(search)));
  return (
    <ContainerFAQ>
      <HeaderFAQ>
        <h1>{t('ajuda')}</h1>
        <p>
          {filteredOptions.length}
          {' '}
          {t('topicosDisponiveis')}
        </p>
      </HeaderFAQ>
      <ContainerArea>
        <SearchNewIcon color={colors.text['main-900']} />
        <input
          type="text"
          placeholder={t('buscar')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            border: 'none',
            outline: 'none',
            fontSize: 12,
            flex: 1,
            backgroundColor: 'transparent',
            width: '100%',
          }}
        />
      </ContainerArea>
      {
        filteredOptions.map((item, index) => (
          <FaqQuestion key={index} question={item.question} answer={item.answer} dataTestId={item.dataTestId} index={index} questionOpen={questionOpen} setQuestionOpen={setQuestionOpen} />
        ))
      }
      <FooterComponent style={{ alignItems: 'center', justifyContent: 'center', marginTop: 20 }} text={t('aindaFicouAlgumaDuvida')} />
    </ContainerFAQ>
  );
};

export const FaqQuestion = ({
  question, answer, index, questionOpen, setQuestionOpen, dataTestId,
}: { question: string; answer: Answer, index: number, questionOpen: number | null, setQuestionOpen: (index: number | null) => void, dataTestId: string }): JSX.Element => (
  <ContainerQuestion key={index} open={questionOpen === index} data-testid={dataTestId}>
    <HeaderQuestion rotate={questionOpen === index ? '-90deg' : '90deg'} onClick={() => setQuestionOpen(questionOpen === index ? null : index)}>
      <div>
        <div>
          <span>{index + 1}</span>
          <span>.</span>
        </div>
        <h2>{question}</h2>
      </div>
      <button type="button">
        <ChevronRight color={colors.text['main-900']} />
      </button>
    </HeaderQuestion>
    {questionOpen === index && (
      <div style={{ padding: '0px 20px' }}>
        <FaqItemAnswer answer={answer} />
        <FooterComponent text={t('naoConseguiuFazerSozinho')} />
      </div>
    )}
  </ContainerQuestion>
);

const FooterComponent = ({ text, style }: { text: string; style?: React.CSSProperties }) => (
  <Footer style={style}>
    <p>{text}</p>
    <div data-testid="controle_inteligente-tag-botao_contatar_suporte-faq" onClick={() => window.open(getLinkSupport(), '_blank')}>
      <span>{t('contatarSuporte')}</span>
      <img src={externalLink} alt="Link externo" />
    </div>
  </Footer>
);

type Answer = {
  text?: string;
  list?: string[];
};
interface FaqItemProps {
  answer: Answer;
}

function FaqItemAnswer({ answer }: FaqItemProps) {
  return (
    <div className="faq-item">
      {answer.text && <p>{answer.text}</p>}
      {answer.list && (
        <ul>
          {answer.list.map((ans, i) => (
            <li key={i}>{ans}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
